import type { IncomingOrdersMapValue, PurchaseOrdersMapValue } from "~/hooks/useCollectionTableData"

export function combineOrdersMaps(
  incomingOrdersMap: Map<string, IncomingOrdersMapValue> | undefined,
  purchaseOrdersMap: Map<string, PurchaseOrdersMapValue> | undefined,
): Map<string, number> {
  const combined = new Map<string, number>()

  if (incomingOrdersMap) {
    for (const [variantId, data] of incomingOrdersMap) {
      combined.set(variantId, (combined.get(variantId) ?? 0) + (data.total ?? 0))
    }
  }

  if (purchaseOrdersMap) {
    for (const [variantId, data] of purchaseOrdersMap) {
      combined.set(variantId, (combined.get(variantId) ?? 0) + data.sent)
    }
  }

  return combined
}
